interface MediaMap {
    [key: string]: string;
}

class StickyOnScroll {
    static SELECTORS = {
        NODE: ".sticky-scroll"
    };

    private readonly node: HTMLElement;
    private readonly target: HTMLElement;
    private readonly mediaMap: MediaMap = {};

    constructor(node: HTMLElement) {
        this.node = node;
        this.target = document.querySelector<HTMLElement>(this.node.dataset.target);

        if (this.node.dataset.media) {
            let threshold = 0;
            this.node.dataset.media.split(",").reduce((p, c) => {
                const [k, v] = c.trim().split("|");
                p[k] = v;
                return p;
            }, this.mediaMap);

            if (this.node.dataset.intersectionThreshold) {
                threshold = parseFloat(this.node.dataset.intersectionThreshold);
            }

            const observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold });
            observer.observe(this.node);
        }
    }

    handleIntersection(entries: IntersectionObserverEntry[]) {
        for (const entry of entries) {
            if (entry.target === this.node) {
                for (const className of Object.values(this.mediaMap)) {
                    this.target.classList.remove(className);
                }
                const match = Object.keys(this.mediaMap).find((k) => {
                    return window.matchMedia(k).matches;
                });
                this.target.classList.toggle(
                    this.mediaMap[match],
                    !entry.isIntersecting && entry.boundingClientRect.top < 0
                );
            }
        }
    }
}

document.querySelectorAll(StickyOnScroll.SELECTORS.NODE).forEach((n: HTMLElement) => {
    new StickyOnScroll(n);
});
